/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { IconTypes } from '@eika/icon';
import { LinkCard } from '@eika/link-panel';

import { Header } from '../../components/header/header';
import { urler } from '../../router/router-urler';
import { Skademeldingstype } from '../../types/generated-types';
import { dataTrackIdPrefix } from '../../utils/piwik-utils';
import { getExternalUrlForSkadekategori, getExternalUrlForSkadetype } from '../deep-link-handler';
import { Skadekategori } from '../deep-link-handler/skadekategori';
import Container from './container';
import { partnerLinks } from './partner-urler';

const {
    KONTOER_24,
    BIL_24,
    FORSIKRINGSBEVIS_REISE_24,
    HUS_24,
    FAMILIE_24,
    HUND_24,
    BUTIKK_24,
    BONDEGARD_24,
    PENN_24,
    GRUPPE_24,
    ELSPAREKSYKKEL_24,
} = IconTypes;

export const to = (url: string) => `#${url}`;
const { ettersendingUrl } = urler();

export const generateDataTrackIdForLinkOnPartner = (kategoriId: string): string =>
    `${dataTrackIdPrefix}-partner-landingsside-${kategoriId}-link`;

const skadeMeldingsTyper: {
    title: string;
    url: string;
    icon: IconTypes;
    'data-track-id': string;
    textOne?: string;
}[] = [
    {
        url: to(ettersendingUrl),
        title: 'Har du allerede meldt inn en skade?',
        textOne: 'Oppdater saken din her',
        icon: KONTOER_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner('ettersending'),
    },
    {
        url: getExternalUrlForSkadekategori(Skadekategori.Kjoretoy),
        title: 'Bil og andre kjøretøy',
        icon: BIL_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Kjoretoy.valueOf()),
    },
    {
        url: getExternalUrlForSkadetype(Skademeldingstype.SmaElektriskeKjoretoy),
        title: 'Elsparkesykkel',
        icon: ELSPAREKSYKKEL_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner('sma-elektriske-kjoretoy'),
    },
    {
        url: getExternalUrlForSkadekategori(Skadekategori.Bat),
        title: 'Båt',
        icon: IconTypes.BAT_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Bat.valueOf()),
    },
    {
        url: getExternalUrlForSkadekategori(Skadekategori.Reise),
        title: 'Reise',
        icon: FORSIKRINGSBEVIS_REISE_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Reise.valueOf()),
    },
    {
        url: getExternalUrlForSkadekategori(Skadekategori.HusOgHytte),
        title: 'Hus og hytte',
        icon: HUS_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner('hus-og-hytte'),
    },
    {
        url: getExternalUrlForSkadekategori(Skadekategori.Innbo),
        title: 'Innbo og eiendeler',
        icon: IconTypes.INNBOFORSIKRING_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Innbo.valueOf()),
    },
    {
        url: to(partnerLinks.livOgHelse),
        title: 'Liv og helse',
        icon: FAMILIE_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner('liv-og-helse'),
    },
    {
        url: getExternalUrlForSkadekategori(Skadekategori.Dyr),
        title: 'Dyr',
        icon: HUND_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Dyr.valueOf()),
    },
    {
        url: to(partnerLinks.naring),
        title: 'Næring',
        icon: BUTIKK_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Naring.valueOf()),
    },
    {
        url: to(partnerLinks.landbruk),
        title: 'Landbruk',
        icon: BONDEGARD_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Landbruk.valueOf()),
    },
    {
        url: getExternalUrlForSkadekategori(Skadekategori.Rettshjelp),
        title: 'Søk om rettshjelp',
        icon: PENN_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Rettshjelp.valueOf()),
    },
    {
        url: getExternalUrlForSkadekategori(Skadekategori.Ansvar),
        title: 'Ansvar',
        icon: GRUPPE_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Ansvar.valueOf()),
    },
];
const header = (
    <>
        <Header title="Meld skade" />
        <p>
            Du kan enkelt melde skade ved å finne din skadekategori i menyen under. Her kan du også ettersende vedlegg,
            informasjon eller spørsmål i en pågående skadesak.
        </p>
    </>
);

export const PartnerComponent = () => (
    <Container header={header}>
        <h3>Hva vil du melde skade på?</h3>
        {skadeMeldingsTyper
            .map((props) => ({
                ...props,
                key: props.title.replace(/\s/g, '_'),
                onClick: () => window.scroll(0, 0),
            }))
            .map((props) => (
                <LinkCard key={props.key} {...props} />
            ))}
    </Container>
);
